export default "__VITE_ASSET__BR3iBkQ9__"